import { render, staticRenderFns } from "./RevisionSolicitudQueja.vue?vue&type=template&id=0375fe7d&scoped=true"
import script from "./RevisionSolicitudQueja.vue?vue&type=script&lang=js"
export * from "./RevisionSolicitudQueja.vue?vue&type=script&lang=js"
import style0 from "./RevisionSolicitudQueja.vue?vue&type=style&index=0&id=0375fe7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0375fe7d",
  null
  
)

export default component.exports